import React from "react";
import { Card, Modal, Icon } from "antd";
import { Table } from "components/table";
// import PropTypes from "prop-types";
import AddUserForm from "./../forms/add-user-form";
import AddGroupForm from "./../forms/add-group-form";
import { USERS_LIST_COLS, GROUPS_LIST_COLS } from "constants/table-columns";
import { List } from "immutable";

class UsersAndGroupsView extends React.Component {
    state = {
        currentPage: 1,
        showUserAddModal: false,
        showGroupAddModal: false,
        userData: new List([])
    };
    pages = [1];
    pageSize = 10;

    toggleUserAddModal = () => {
        this.setState({
            showUserAddModal: !this.state.showUserAddModal
        });
    };
    toggleGroupAddModal = () => {
        this.setState({
            showGroupAddModal: !this.state.showGroupAddModal
        });
    };
    render() {
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.showUserAddModal}
                    maskClosable={true}
                    destroyOnClose
                    onCancel={this.toggleUserAddModal}>
                    <AddUserForm />
                </Modal>
                <Modal
                    visible={this.state.showGroupAddModal}
                    maskClosable={true}
                    destroyOnClose
                    onCancel={this.toggleGroupAddModal}
                    title={"Add Group"}>
                    <AddGroupForm />
                </Modal>
                <Card
                    title={"Users List"}
                    extra={
                        <a
                            key="add-user"
                            className={"mr-5"}
                            onClick={this.toggleUserAddModal}>
                            <Icon type={"add"} /> Add User
                        </a>
                    }>
                    <Table
                        columns={USERS_LIST_COLS}
                        data={this.state.userData}
                        pagination={true}
                        showTopSection={false}
                        // pageSize={}
                    />
                </Card>
                <Card
                    title={"Groups List"}
                    extra={
                        <a
                            key="add-group"
                            className={"mr-5"}
                            onClick={this.toggleGroupAddModal}>
                            <Icon type={"add"} /> Add Group
                        </a>
                    }>
                    <Table
                        columns={GROUPS_LIST_COLS}
                        data={this.state.userData}
                        pagination={true}
                        showTopSection={false}
                        // pageSize={}
                    />
                </Card>
            </React.Fragment>
        );
    }
}
UsersAndGroupsView.propTypes = {};
export default UsersAndGroupsView;
